const DynamicMapLegend = ({ min, max, getGreenShade }) => {
    // Define ranges (adjust as needed)
    const ranges = [
      { label: '0', value: 0 },
      { label: '9', value: 5 },
      { label: '10–29', value: 29 },
      { label: '30–49', value: 49 },
      { label: '50-99', value: 99 },
      { label: '100-199', value: 199 },
      { label: '200-499', value: 499 },
      { label: '500-699', value: 699 },
      { label: '700-999', value: 999 },
      { label: '1000+', value: max }
    ];

    const filteredRanges = ranges.filter((range, index) =>
        index === 0 || max >= range.value
    );
  
    return (
      <div style={{
        position: 'absolute',
        bottom: 20,
        left: 20,
        padding: '10px',
        background: 'rgba(255,255,255,0.9)',
        borderRadius: 8,
        boxShadow: '0 0 5px rgba(0,0,0,0.3)',
        fontSize: 12,
        zIndex: 1000
      }}>
        <strong>Agent Count Legend</strong>
        <div style={{ marginTop: 6 }}>
          {filteredRanges.map((range, idx) => {
            const prev = idx === 0 ? 0 : filteredRanges[idx - 1].value + 1;
            const label = idx === 0 ? '0' : `${prev}–${range.value}`;
            const shade = getGreenShade(range.value, min, max);
  
            return (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                <div style={{
                  width: 20,
                  height: 20,
                  background: shade,
                  border: '1px solid #ccc',
                  marginRight: 8
                }} />
                <span>{label}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  
  export default DynamicMapLegend;